<template>
  <div class="color-bespoke-colors">
      <div class="uppercase xs-text xs-content">To specify your bespoke colour scheme, simply enter ral references below.</div>
      <div class="uppercase xs-text mt-3 xs-content">Selected custom color will not show on the configurator and the Passoni design team will share with you final rendering if you decide to proceed with ordering a bike.</div>
    <div class="form-group mt-4">
        <label for="">
            <h5>Primary color</h5>
            <input type="text" name="primaryColor" v-model="primaryColorInput" id="">
        </label>
    </div>
    <div class="form-group">
        <label for="">
            <h5>Secondary color</h5>
            <input type="text" name="secondaryColor" v-model="secondaryColorInput" id="">
        </label>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import colorPicker from "../sub-components/color-picker.vue";

Vue.component("color-picker", colorPicker);

export default {
  name: "color-bespoke-colors",
  data() {
    return {
      currentSubStep: 0,
      subSteps: [
        'primary',
        'secondary'
      ]
    };
  },
  computed: {
      primaryColorInput: {
          get: function() {
              return this.primaryColor;
          },
          set: function(e) {
              this.$emit("set-primary-color", e);
          }
      },
      secondaryColorInput: {
          get: function() {
              return this.secondaryColor;
          },
          set: function(e) {
              this.$emit("set-secondary-color", e);
          }
      }
  },
  props: ["configuratorSteps", "results", "currentStep", "primaryColor", "secondaryColor"],
  methods: {
    goNext: function () {
      if (this.currentSubStep < this.subSteps.length - 1) {
        this.currentSubStep++;
      } else {
        this.$emit("go-next");
      }
    },
    goBack: function () {
      if (this.currentSubStep > 0) {
        this.currentSubStep--;
      } else {
        this.$emit("go-back");
      }
    },
    setPrimaryColor: function (e) {
      this.$emit("set-primary-color", e);
    },
    setSecondaryColor: function (e) {
      this.$emit("set-secondary-color", e);
    },
  },
  created() {
      this.setPrimaryColor(null);
      this.setSecondaryColor(null);
  }
};
</script>

<style lang="scss" scoped>
.color-bespoke-colors {
    h5 {
        display: inline-block;
        width: 140px;
    }
    
}
</style>

